/*
 * Il risparmio nel blocco "Vantaggi" della scheda prodotto.
 *
 * Perche': il tema conosce solo il prezzo barrato del prodotto (compare at),
 * e in quel caso la cifra la stampa gia' Liquid. Gli sconti automatici Regios
 * pero' non stanno nel prodotto: li applica l'app riscrivendo il prezzo dopo
 * il caricamento, quindi il risparmio si puo' sapere solo leggendo i due
 * prezzi a video.
 *
 * Come: dal prezzo della scheda (#price-<sezione>) si prendono il prezzo
 * corrente e quello barrato, si sottraggono e si scrive la differenza nel
 * riquadro, che resta nascosto se non c'e' niente da risparmiare. Un
 * MutationObserver rifa' il conto quando l'app o il cambio variante
 * riscrivono il prezzo.
 *
 * Gli importi si formattano con FoxTheme.Currency, cioe' col formato valuta
 * del negozio: se non fosse disponibile il riquadro resta nascosto, meglio
 * niente che una cifra scritta a modo nostro.
 */
(() => {
  'use strict';

  if (window.ProductPerks) return;

  const ITEM = '[data-perks-savings-item]';
  const VALUE = '[data-perks-savings]';

  const parseMoney = (text) => {
    if (!text) return null;
    const cleaned = text.replace(/[^\d.,]/g, '');
    if (!cleaned) return null;
    const comma = cleaned.lastIndexOf(',');
    const dot = cleaned.lastIndexOf('.');
    let normalized;
    if (comma > dot) {
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    } else if (dot > comma) {
      normalized = cleaned.replace(/,/g, '');
    } else {
      normalized = cleaned.replace(/[.,]/g, '');
    }
    const value = parseFloat(normalized);
    return Number.isFinite(value) ? Math.round(value * 100) : null;
  };

  const money = (cents) => {
    const theme = window.FoxTheme;
    const format = theme && theme.settings && theme.settings.moneyFormat;
    if (!format || !theme.Currency || typeof theme.Currency.formatMoney !== 'function') return '';
    try {
      return theme.Currency.formatMoney(cents, format) || '';
    } catch (error) {
      return '';
    }
  };

  const update = () => {
    document.querySelectorAll(ITEM).forEach((item) => {
      const scope = item.closest('product-info') || document;
      const price = scope.querySelector('[id^="price-"]');
      const value = item.querySelector(VALUE);
      if (!price || !value) return;

      const saleCents = parseMoney(price.querySelector('.f-price__sale .f-price-item--sale')?.textContent);
      const regularCents = parseMoney(price.querySelector('.f-price__sale .f-price-item--regular')?.textContent);

      const savings = saleCents !== null && regularCents !== null ? regularCents - saleCents : 0;
      const formatted = savings > 0 ? money(savings) : '';

      if (value.textContent.trim() !== formatted) value.textContent = formatted;
      item.toggleAttribute('hidden', formatted === '');
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  };

  const start = () => {
    update();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  window.ProductPerks = { update };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
